<template>
  <svg
    width="12"
    height="15"
    viewBox="0 0 12 15"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path d="M6.53331 3.96667C6.53331 4.17083 6.59169 4.34583 6.73749 4.4625C6.85419 4.60833 7.02915 4.66667 7.23333 4.66667H11.2V14.2333C11.2 14.4375 11.1125 14.6125 10.9958 14.7292C10.85 14.875 10.675 14.9334 10.5 14.9334H0.699998C0.49583 14.9334 0.320834 14.875 0.204166 14.7292C0.0583332 14.6125 0 14.4375 0 14.2333V0.699999C0 0.525003 0.0583332 0.350001 0.204166 0.204167C0.320834 0.0875004 0.49583 0 0.699998 0H6.53331V3.96667ZM3.99583 12.8042C4.75417 13.0959 5.45416 13.1542 6.12501 12.9792C6.79581 12.8334 7.37919 12.5125 7.84581 12.0167C8.31249 11.55 8.63331 10.9667 8.77917 10.2667H4.66666V6.15416C3.61666 6.3875 2.82916 6.97082 2.30416 7.90418C1.77916 8.83748 1.72083 9.85832 2.12917 10.9667C2.30416 11.375 2.5375 11.7542 2.85833 12.075C3.17917 12.3958 3.55833 12.6292 3.99583 12.8042ZM9.09999 9.33331C9.09999 8.37086 8.75001 7.5542 8.07915 6.85418C7.37919 6.18332 6.56247 5.83334 5.6 5.83334V9.33331H9.09999ZM10.9958 3.0625C11.1125 3.20834 11.2 3.38333 11.2 3.55833V3.73334H7.46667V0H7.64169C7.81665 0 7.99167 0.0875004 8.13747 0.204167L10.9958 3.0625Z" fill="currentColor"/>
  </svg>
</template>

<script setup lang="ts">

</script>
